// Parses Deribit's dated-future instrument-name convention (e.g.
// "BTC-24JUL26") into a "YYYY-MM-DD" tenor + expiry timestamp, matching the
// vol surface's own tenor keys so futures_snapshot's real market prices can
// be joined onto build-carry-curve.ts's per-tenor rows in
// attach-futures-snapshot.ts. Deribit dated futures settle 08:00 UTC — same
// convention build-carry-curve.ts's expiryToDate fallback already assumes.
const MONTHS: Record<string, string> = {
  JAN: '01',
  FEB: '02',
  MAR: '03',
  APR: '04',
  MAY: '05',
  JUN: '06',
  JUL: '07',
  AUG: '08',
  SEP: '09',
  OCT: '10',
  NOV: '11',
  DEC: '12',
};

export interface ParsedDeribitExpiry {
  tenor: string; // "YYYY-MM-DD"
  expiryMs: number;
}

export function parseDeribitExpiry(instrumentName: string): ParsedDeribitExpiry | null {
  const match = instrumentName.match(/-(\d{1,2})([A-Z]{3})(\d{2})$/);
  if (!match) return null;
  const [, dd, mon, yy] = match;
  const month = MONTHS[mon];
  if (!month) return null;
  const tenor = `20${yy}-${month}-${dd.padStart(2, '0')}`;
  const expiryMs = new Date(`${tenor}T08:00:00Z`).getTime();
  if (!Number.isFinite(expiryMs)) return null;
  return { tenor, expiryMs };
}
